import { InspectorControls } from "@wordpress/block-editor";
import { PanelBody, SelectControl } from "@wordpress/components";

export const Edit = (props) => {
    const { attributes, setAttributes } = props;
    const { justify } = attributes;

    const handleJustifyChange = (newJustify) => {
        setAttributes({ justify: newJustify });
    };

    return (
        <>
            {/* Inspector Controls per selezionare l'allineamento */}
            <InspectorControls>
                <PanelBody title="Allineamento" initialOpen={true}>
                    <SelectControl
                        label="Allineamento Flex"
                        value={justify}
                        options={[
                            { label: "Sinistra", value: "flex-start" },
                            { label: "Centro", value: "center" },
                            { label: "Destra", value: "flex-end" },
                            { label: "Spazio tra gli elementi", value: "space-between" },
                            { label: "Spazio attorno agli elementi", value: "space-around" },
                            { label: "Spazio uniformemente", value: "space-evenly" },
                        ]}
                        onChange={handleJustifyChange}
                    />
                </PanelBody>
            </InspectorControls>

            {/* Contenuto del blocco */}
            <article style={{ display: 'flex', justifyContent: justify }}>
                <a
                    className="store-badge"
                    id="google-play"
                >
                    <img
                        loading="lazy"
                        alt="Get it on Google Play"
                        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                    />
                </a>
                <a
                    className="store-badge"
                >
                    <img
                        loading="lazy"
                        src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1619395200"
                        alt="Download on the App Store"
                    />
                </a>
            </article>
        </>
    );
};